<template>
  <div class="image-live">
    <div class="image-live-loading" v-show="loading">
      <div class="icon-loading"></div>
    </div>
    <div class="live-image-list" v-if="list && list.length > 0">
      <div class="live-image-item" v-for="(item, i) in list" :key="i">
        <div class="live-image-box" @click="viewImage(item)">
          <img :src="item.img" class="live-image" />
        </div>
      </div>
    </div>
    <div class="live-image-empty" v-else-if="list">暂无图片</div>
  </div>
</template>

<script>

    import {previewImage} from "../common/wxTool";

    export default {
        name: "image-live",
        props: {
            url: String
        },
        data() {
            return {
                loading: false,
                list: null,
                timer: 0,
            }
        },
        watch: {
            url() {
                this.list = null;
                this.getAlbum();
            }
        },
        created() {
            this.getAlbum();
            this.pollImage();
        },
        beforeDestroy() {
            this.clearTimer();
        },
        methods: {
            // 获取图片列表
            getAlbum(hideLoading) {
                const url = this.url;
                if(!url) return Promise.reject();
                if(!hideLoading) {
                    this.loading = true;
                }
                return this.$axios({
                    url: `https://pptr.api.qihe.live/zszb/album?url=${encodeURIComponent(url)}`,
                    loadingText: false,
                }).then(res => {
                    if(res.success) {
                        this.list = res.result || [];
                    } else {
                        this.list = []
                    }
                }).finally(() => this.loading = false);
            },
            pollImage() {
                this.timer = setTimeout(() => {
                    this.getAlbum(true).finally(() => this.pollImage())
                }, 5000)
            },
            clearTimer() {
                if(this.timer)  {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            },
            viewImage(item) {
                previewImage(item.img, this.list.map(item => item.img))
            }
        }
    }
</script>

<style lang="less">
.image-live {
  padding: 0 32px;
}
.image-live-loading {
  padding: 24px 0;
  text-align: center;
  .icon-loading {
    font-size: 32px;
    color: #FFCD86;
  }
}
.live-image-list {
  display: flex;
  flex-wrap: wrap;
  margin: 8px -8px;
}
.live-image-item {
  padding: 8px;
  width: 50%;
}
.live-image-box {
  height: 200px;
  font-size: 0;
  line-height: 1;
}
.live-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.live-image-empty {
  margin-top: 48px;
  text-align: center;
  color: #FFFFFF;
}
</style>
